import React, { useState } from "react";
import emailjs from "@emailjs/browser";
import "../OnlineForm.css";


function OnlineForm() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    address: "",
    course: "",
    mode: "",
    notes:"",
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };
const handleSubmit = (e) => {
  e.preventDefault();

  emailjs
    .send(
      "service_orsuftd",
      "template_wp2hfpc",
      formData,
      "ryEoMiFW-7_Y88ZaM"
    )
    .then(() => {
      alert("Registration Submitted Successfully!");

      setFormData({
        name: "",
        email: "",
        phone: "",
        address: "",
        course: "",
        mode: "",
        notes: "",
      });
    })
    .catch((error) => {
      console.log(error);
      alert("Failed to send email.");
    });
};

  return (
    <div className="online-page">

      <div className="container p-5">

        <div className="row main-box">

          {/* LEFT PANEL */}

          <div className="col-lg-4 left-panel">
             <p>Kickstart your career with our 3-Month Internship Program!
              Gain hands-on experience,
              work on real-world projects,
              and develop industry-relevant
              skills.
              Upon successful completion,
              you will be awarded an
              Internship Certificate.
            </p>
            <div className="blue-line"></div>
            <img
              src="/qr.jpeg"
              className="qr-img"
              alt=""
            />

            <div className="info-container">
            <div className="info-card">
              <div><br></br>
                <h5>Duration</h5>
                <h4>3 Months</h4>
              </div>
            </div>

            <div className="info-card">
              <div><br></br>
                <h5>Fee</h5>
                <h4>₹5,000</h4>
              </div>

            </div>

            <div className="info-card">
              <div>

                <h5>Certificate</h5>

                <p>
                  Provided after successful completion
                </p>

              </div>
              </div>

            </div>

          </div>

          {/* RIGHT PANEL */}

          <div className="col-lg-8 form-panel">

            <h2>
             
              Online Internship Registration Form
            </h2>

            <form onSubmit={handleSubmit}>

              <div className="row">

                <div className="col-md-6">

                  <label>Full Name *</label>

                  <div className="input-box">
                   
                    <input
                      type="text"
                      placeholder="Enter your full name"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                    />
                  </div>

                </div>

                <div className="col-md-6">

                  <label>Email Address *</label>

                  <div className="input-box">

                    <input
                      type="email"
                      placeholder="Enter your email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                    />

                  </div>

                </div>

              </div>

              <div className="row mt-3">

                <div className="col-md-6">

                  <label>Phone Number *</label>

                  <div className="input-box">

                    <input
                      type="text"
                      placeholder="Enter phone number"
                      name="phone"
                      value={formData.phone}
                      onChange={handleChange}
                    />

                  </div>

                </div>

                <div className="col-md-6">

                  <label>Address *</label>

                  <div className="input-box textarea-box">
  <textarea
    placeholder="Enter your address"
    name="address"
    value={formData.address}
    onChange={handleChange}
  />
</div>

                </div>

              </div>

              <label className="mt-4">
                Course Detail *
              </label>

              <select
                className="form-select mt-2"
                name="course"
                value={formData.course}
                onChange={handleChange}
              >
                <option>Select Course</option>

                <option>PHP</option>

                <option>HTML CSS Bootstrap</option>

                <option>React</option>

                <option>WordPress</option>

                <option>Laravel</option>

                <option>MySQL(Database)</option>

              </select>

         {/*     <div className="course-grid">

                <div className="course-card">
                 
                  PHP
                </div>

                <div className="course-card">
            
                  HTML CSS Bootstrap
                </div>

                <div className="course-card">
                  
                  React
                </div>

                <div className="course-card">
                  
                  WordPress
                </div>

                <div className="course-card">
                 
                  Laravel
                </div>

                <div className="course-card">
                
                  MySQL
                </div>

              </div>

              <h5 className="mt-4">
                Course Mode
              </h5>

              <div className="mode-row">

                <label className="mode-card">

                  <input
                    type="radio"
                    name="mode"
                    value="Online"
                    onChange={handleChange}
                  />

                 

                  Online

                </label>

                <label className="mode-card">

                  <input
                    type="radio"
                    name="mode"
                    value="Offline"
                    onChange={handleChange}
                  />
                  Offline

                </label>

              </div>*/}

            <div className="m-4">

              <label className="d-block mb-2">
                Course Mode
              </label>

              <div className="form-check form-check-inline">

                <input
                  className="form-check-input"
                  type="radio"
                  name="mode"
                  value="Online"
                  checked={formData.mode === "Online"}
                  onChange={handleChange}
                />

                <label className="form-check-label">
                  Online
                </label>

              </div>

              <div className="form-check form-check-inline">

                <input
                  className="form-check-input"
                  type="radio"
                  name="mode"
                  value="Offline"
                  checked={formData.mode === "Offline"}
                  onChange={handleChange}
                />

                <label className="form-check-label">
                  Offline
                </label>

              </div>

            </div>





              <label className="mt-4">
                Message
              </label>

              <textarea
                className="notes-box"
                rows="4"
                placeholder="Write your notes..."
                name="notes"
                value={formData.notes}
                onChange={handleChange}
              ></textarea>

              <div className="submit-row">

                <button>
                  Submit Application
                </button>

              </div>

            </form>

          </div>

        </div>

      </div>

    </div>
  );
}

export default OnlineForm;